import { colors, fonts } from '../theme';

const Contact = ({ onOpenContact }) => (
  <section id="contact" style={{ padding: 'clamp(56px, 8vw, 96px) clamp(20px, 5vw, 48px)', background: colors.bgAlt }}>
    <div style={{ maxWidth: 1080, margin: '0 auto', textAlign: 'center' }}>
      <p style={{ color: colors.teal, fontSize: 12.5, fontFamily: fonts.mono, letterSpacing: '0.14em', textTransform: 'uppercase', fontWeight: 600, marginBottom: 16 }}>Contact</p>
      <h2 style={{ fontSize: 'clamp(26px,3.4vw,38px)', fontFamily: fonts.display, lineHeight: 1.3, color: colors.navy, marginBottom: 16 }}>
        Let's connect
      </h2>
      <div style={{ maxWidth: 560, margin: '0 auto' }}>
        <p style={{ color: colors.slateDark, fontSize: 16, lineHeight: 1.7, marginBottom: 10 }}>
          If you're a manufacturer, we'd be happy to connect and explore how Digital Material Passport can help unlock value for you.
        </p>
        <p style={{ color: colors.slateDark, fontSize: 16, lineHeight: 1.7 }}>
          If you're a domain expert or thought leader with feedback to share, we'd love to hear from you too.
        </p>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 24, flexWrap: 'wrap', marginTop: 28 }}>
        <button onClick={() => onOpenContact('contact')} className="cta" aria-label="Get in touch"
          style={{ background: `linear-gradient(135deg,${colors.teal},${colors.tealDark})`, border: 'none', borderRadius: 10, padding: '14px 30px', color: '#fff', fontSize: 15, fontWeight: 700, cursor: 'pointer', transition: 'all 0.2s' }}>
          Get in touch →
        </button>
        <a href="mailto:support@nthralabs.com" style={{ color: colors.navy, fontSize: 15, fontWeight: 600 }}>
          support@nthralabs.com
        </a>
      </div>
    </div>
  </section>
);

export default Contact;
